// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-modules[data-v-64d2e25b]{--modules-gap:40px;display:flex;flex-direction:column;gap:var(--modules-gap)}.home-modules .shadow-sr[data-v-64d2e25b]{margin-bottom:calc(var(--modules-gap)*-1)}", ""]);
// Exports
module.exports = exports;
